import * as React from 'react'
import { useContext, useState } from 'react'
import Button from 'react-bootstrap/Button'
import { AuthContext } from '../../context/authContext'
import AuthModal from '../auth/AuthModal'

const Header = () => {
  const { isAuth } = useContext(AuthContext)
  const [showAuthModal, setShowAuthModal] = useState(false)

  const handleAuthClick = () => {
    if (!isAuth) {
      setShowAuthModal(true)
    }
  }

  return (
    <>
      <div style={{ position: 'absolute', top: '20px', right: '20px', zIndex: 1000 }}>
        {!isAuth && (
          <Button variant="outline-light" size="sm" onClick={handleAuthClick}>
            Login
          </Button>
        )}
      </div>

      <AuthModal show={showAuthModal} onHide={() => setShowAuthModal(false)} />
    </>
  )
}

export default Header
